document.addEventListener("DOMContentLoaded", () => {

  const carousel = document.querySelector(".luxury-carousel");

  if (!carousel) return;

  const videos = carousel.querySelectorAll("video");
  const prevBtn = document.querySelector(".carousel-btn.prev");
  const nextBtn = document.querySelector(".carousel-btn.next");

  /*-----------------------------
      Navigation
  ------------------------------*/

  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      carousel.scrollBy({
        left: 340,
        behavior: "smooth"
      });
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      carousel.scrollBy({
        left: -340,
        behavior: "smooth"
      });
    });
  }

  /*-----------------------------
      Drag Scroll
  ------------------------------*/

  let isDown = false;
  let startX;
  let scrollLeft;

  carousel.addEventListener("mousedown", (e) => {
    isDown = true;
    carousel.classList.add("dragging");
    startX = e.pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
  });

  document.addEventListener("mouseup", () => {
    isDown = false;
    carousel.classList.remove("dragging");
  });

  carousel.addEventListener("mouseleave", () => {
    isDown = false;
    carousel.classList.remove("dragging");
  });

  carousel.addEventListener("mousemove", (e) => {

    if (!isDown) return;

    e.preventDefault();

    const x = e.pageX - carousel.offsetLeft;

    const walk = (x - startX) * 1.5;

    carousel.scrollLeft = scrollLeft - walk;

  });

  /*-----------------------------
      Videos
  ------------------------------*/

  videos.forEach((video) => {

    video.muted = true;
    video.playsInline = true;
    video.loop = true;

    const card = video.closest(".card");
    const progress = card.querySelector(".progress-bar span");
    const muteButton = card.querySelector(".mute-btn");

    function pauseOthers() {

      videos.forEach((v) => {

        if (v !== video) {

          v.pause();

          v.closest(".card").classList.remove("playing");

        }

      });

    }

    video.addEventListener("click", () => {

      if (video.paused) {

        pauseOthers();

        video.play();

        card.classList.add("playing");

      } else {

        video.pause();

        card.classList.remove("playing");

      }

    });

    if (muteButton) {

      muteButton.addEventListener("click", (e) => {

        e.stopPropagation();

        video.muted = !video.muted;

        muteButton.innerHTML = video.muted ? "🔇" : "🔊";

      });

    }

    video.addEventListener("timeupdate", () => {

      if (!progress) return;

      if (!video.duration) return;

      const percent = (video.currentTime / video.duration) * 100;

      progress.style.width = percent + "%";

    });

    video.addEventListener("ended", () => {

      card.classList.remove("playing");

      if (progress)
        progress.style.width = "0%";

    });

  });

  /*-----------------------------
      Autoplay when Visible
  ------------------------------*/

  const observer = new IntersectionObserver((entries) => {

    entries.forEach((entry) => {

      const video = entry.target;

      const card = video.closest(".card");

      if (entry.isIntersecting && entry.intersectionRatio > 0.75) {

        videos.forEach((v) => {

          if (v !== video) {

            v.pause();

            v.closest(".card").classList.remove("playing");

          }

        });

        video.play().catch(() => {});

        card.classList.add("playing");

      } else {

        video.pause();

        card.classList.remove("playing");

      }

    });

  }, {
    threshold: 0.75
  });

  videos.forEach((video) => {

    observer.observe(video);

  });

});